import {
    FETCH_BRAND_INSTAGRAM_DETAILS_BEGIN,
    FETCH_BRAND_INSTAGRAM_DETAILS_SUCCESS,
    FETCH_BRAND_INSTAGRAM_DETAILS_FAILURE,
    SHOW_IMAGE,
    RESET_BRAND_INSTAGRAM
} from '../constants/brandInstagramActionTypes';

const initialState = {
    instaImages: [],
    isLoading: true,
    selectedImage: '',
    error: {}
}

export default function (state, action) {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case FETCH_BRAND_INSTAGRAM_DETAILS_BEGIN:
            return {
                ...state,
            };
        case FETCH_BRAND_INSTAGRAM_DETAILS_SUCCESS:
            return {
                ...state,
                instaImages: action.payload,
                isLoading: false
            };
        case FETCH_BRAND_INSTAGRAM_DETAILS_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        case SHOW_IMAGE:
            return {
                ...state,
                selectedImage: action.payload
            }
        case RESET_BRAND_INSTAGRAM:
            return initialState;
        default:
            return state;
    }
}
